export enum SlaNotificationTimeSetting {
  DEFAULT_TIME_SETTING = '70',
}
